import { render } from "./TvmVDVIcon.vue?vue&type=template&id=5ed94d46"
import script from "./TvmVDVIcon.vue?vue&type=script&lang=js"
export * from "./TvmVDVIcon.vue?vue&type=script&lang=js"

import "./TvmVDVIcon.vue?vue&type=style&index=0&id=5ed94d46&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__